// extracted by mini-css-extract-plugin
export default {"blogPage":"blog_blogPage__k3N66","link":"blog_link__4gGTy","webisteLink":"blog_webisteLink__-O-RU"};